import Link from '../../Link';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { toReadableDate } from '@hiredigital/lib/helpers/date';
import Styles from './Author.module.scss';

const Author = ({ author, fallbackAuthor, date }) => {
  return (
    <div className={Styles.container}>
      <img
        src={author?.profile?.picture || `/img/avatar.webp`}
        className={Styles.picture}
        alt={author?.name || 'author image'}
      />
      <div className={Styles.details}>
        <p className={Styles.title}>{author?.name || fallbackAuthor?.name}</p>
        <p className={Styles.description}>
          {author?.profile?.headline || (date && toReadableDate(date))}
        </p>
      </div>
    </div>
  );
};

Author.propTypes = {
  author: PropTypes.object,
  fallbackAuthor: PropTypes.object,
};

export default Author;
